import React from 'react';
import './static-card.styles.scss';
import { useTranslation } from 'react-i18next';
import phone_img_1 from '../../../assest/Home/Significantly-1.png';
import phone_img_2 from '../../../assest/Home/phoneImgNew2.png';
import phone_img_3 from '../../../assest/Home/phoneImgNew3.png';
import web3 from '../../../assest/Home/web3.png';
import rocket from '../../../assest/Home/growth.png';
import aim from '../../../assest/Home/optimization.png';

export const StaticCard = () => {
  const { t } = useTranslation();

  return (
    <div className='static-card'>
      <div className='static-card_1'>
        <img src={rocket} alt='icon' className='icon' />
        <p className='static-card-text_bold'>{t('staticCard.card1.title')}</p>
        <p className='static-card-text_light'>{t('staticCard.card1.desc')}</p>
        <img src={phone_img_1} alt='phone__img' className='phone__img' />
      </div>
      <div className='static-card_1'>
        <img src={aim} alt='icon' className='icon' />
        <p className='static-card-text_bold'>{t('staticCard.card2.title')}</p>
        <p className='static-card-text_light'>{t('staticCard.card2.desc')}</p>
        <img src={phone_img_2} alt='phone__img' className='phone__img' />
      </div>
      <div className='static-card_1'>
        <img src={web3} alt='icon' className='icon' />
        <p className='static-card-text_bold'>{t('staticCard.card3.title')}</p>
        <p className='static-card-text_light'>{t('staticCard.card3.desc')}</p>
        <img src={phone_img_3} alt='phone__img' className='phone__img' />
      </div>
    </div>
  );
};
